import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { Location } from "@angular/common";
import { plopInOut } from "../../shared/animation/component.animation";
import { IWebVoucherLandingPage, IWebVoucher } from "./webVoucherSelector.facade";
import { WebVoucherSelectorService } from "./webVoucherSelector.service";

@Component({
  selector: "webVoucherSelector.",
  templateUrl: "./webVoucherSelector.component.html",
  styleUrls: ["./webVoucherSelector.component.scss"],
  providers: [WebVoucherSelectorService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [plopInOut]
})

export class WebVoucherSelectorComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;
  private _shippingCartSubscriber: Subscription;

  private useBrowserHistory: boolean;
  public isSmallView: boolean = false;
  public isLoaded: boolean = false;
  public itemsInBasket: number = 0;

  public webVoucherLandingPage$: Observable<IWebVoucherLandingPage>;
  public webVouchers$: Observable<ReadonlyArray<IWebVoucher>>;
  constructor(private _location: Location
    , private _webVoucherSelectorService: WebVoucherSelectorService
    , private _webShopService: WebShopService
    , private _mainnavService: MainnavService
    , private _router: Router
    , private _routerHelperService: RouterHelperService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _internationalisationService: InternationalisationService
  ) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("WebVoucherSelectorComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit(): void {
    const me = this;
    me.webVoucherLandingPage$ = me._webVoucherSelectorService.webVoucher_landingPage$;
    me.webVouchers$ = me._webVoucherSelectorService.webVouchers$;
    me.isLoaded = true;

    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    me._shippingCartSubscriber = me._webShopService.ShippingCartObserver.subscribe((shippingCartItems) => {
      if (shippingCartItems) {
        me.itemsInBasket = me._webShopService.getTotalCountOfItems();
        //me.PushChanges();
      } else {
        me.itemsInBasket = 0;
        //me.PushChanges();
      }
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._shippingCartSubscriber) {
      me._shippingCartSubscriber.unsubscribe();
    }
  }

  public displayPrice(price: number): boolean {
    return price > 0 ? true : false;
  }

  public formatCurrency(amount: number): string {
    const me = this;
    return me._webShopService.formatCurrency(amount);
  }

  public navigateToWebVoucherDetail(webVoucherId: number) {
    const me = this;
    const locationId = me._webShopService.locationID;
    me._router.navigate(["/webVoucherCustomDetail", webVoucherId, locationId]);
  }

  public navigateBack() {
    const me = this;
    if (me.useBrowserHistory) {
      me._location.back();
    } else {
      const serviceMode = me._webShopService.getServiceMode();
      me._webShopService.HasSingleLocation(serviceMode)
        .then(response => {
          if (response) {
            me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
            me._router.navigate(["/vouchercredit"], { replaceUrl: true });

          } else {
            me._routerHelperService.setRouteTargetDataByKey("useBrowserHistory", me.useBrowserHistory);
            me._router.navigate(["/menulocation"], { replaceUrl: true });
          }
        })
        .catch(e => {
          me._coreLogService.error("WebVoucherSelectorComponent.navigateBack", "_webShopService.HasSingleLocation", e);
        });
    }
  }

  /**if small view, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }
}